import axios from 'axios';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

export default {
    state: {
        quota: false,
    },
    
    actions: {
        getUserQuota({ commit }) {
            console.log('Getting quota...');
            if (navigator.storage && navigator.storage.estimate) {
                navigator.storage.estimate().then(function(estimate) {
                    commit('setQuota', (estimate.usage / estimate.quota * 100).toFixed(2));
                });
            } else {
                commit('setQuota', 0);
            }
        },
    },

    mutations: {
        setQuota(state, data) {
            state.quota = data;
        }
    },

    getters: {
        getQuota: (state) => {
            return state.quota;
        }
    }
};